interface StoredToast {
  message: string
  type: 'success' | 'error' | 'info' | 'warning'
  timestamp: number
  duration?: number
}

const TOAST_STORAGE_KEY = 'pitchup_pending_toasts'
const TOAST_EXPIRY_MS = 30000 // 30 seconds

export function storeToast(
  message: string,
  type: StoredToast['type'] = 'info',
  duration?: number,
): void {
  try {
    const existingToasts = getStoredToasts()
    const newToast: StoredToast = {
      message,
      type,
      timestamp: Date.now(),
      duration,
    }

    existingToasts.push(newToast)
    localStorage.setItem(TOAST_STORAGE_KEY, JSON.stringify(existingToasts))
  } catch (error) {
    console.error('Failed to store toast message:', error)
  }
}

export function getStoredToasts(): StoredToast[] {
  try {
    const stored = localStorage.getItem(TOAST_STORAGE_KEY)
    if (!stored) return []

    const toasts: StoredToast[] = JSON.parse(stored)
    const now = Date.now()

    // Filter out expired toasts
    const validToasts = toasts.filter(
      (toast) => now - toast.timestamp < TOAST_EXPIRY_MS,
    )

    // Update storage if we filtered any out
    if (validToasts.length !== toasts.length) {
      localStorage.setItem(TOAST_STORAGE_KEY, JSON.stringify(validToasts))
    }

    return validToasts
  } catch (error) {
    console.error('Failed to retrieve stored toasts:', error)
    return []
  }
}

export function clearStoredToasts(): void {
  try {
    localStorage.removeItem(TOAST_STORAGE_KEY)
  } catch (error) {
    console.error('Failed to clear stored toasts:', error)
  }
}
